import React from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import moment from 'moment';

import ModalQuestion from '../../ModalQuestion';
import { cancelClaim } from '../../../redux/offers';
import { AnalyticsService } from '../../../services/AnalyticsService';
declare interface Props {
  cancelClaim: Function;
  children: JSX.Element;
  type: string;
  business: Business;
  offer: any;
  attendee: {
    model: {
      name: string;
      avatar?: string;
    };
    id?: string;
    posted_at?: string;
    status?: string;
    spot_type?: string;
    reserved_for?: string;
  };
}

function CancelReservation(props: Props) {
  const id = `CancelReservation${props.attendee.id}`;

  return (
    <>
      {React.cloneElement(props.children, {
        onClick: () => $('#' + id).modal('show'),
      })}
      <ModalQuestion
        title="Cancel Reservation?"
        leftName="NO"
        rightName="YES"
        id={id}
        function={() => {
          props.cancelClaim(
            props.offer.id as string,
            props!.attendee!.id!,
            props.offer.business.id,
            props.type as any
          );
        }}
      >
        {props.attendee.model.name},<br />
        {moment.parseZone(props.attendee.reserved_for).calendar()}
      </ModalQuestion>
    </>
  );
}

export default connect(({ business, offers }: StoreState) => ({ business, offers }), {
  cancelClaim,
})(CancelReservation);
